export default "__VITE_ASSET__9f72f55a__"